import React, { useMemo } from 'react';
import PageInnerTabs from 'components/system/PageInnerTabs';
import EmployeeRecordTabGrid from './EmployeeRecordTabGrid';
import { EMPLOYEE_RECORD_TABS } from './recordTabConfig';

/**
 * 인사기록카드 영역 — 학력·경력·상벌·교육·가족·자격증 탭
 */
const EmployeeRecordTabs = ({ employeeContext }) => {
  const tabsConfig = useMemo(
    () =>
      EMPLOYEE_RECORD_TABS.map((tab) => ({
        id: tab.id,
        label: tab.label,
        component: (props) => <EmployeeRecordTabGrid tabConfig={tab} {...props} />,
      })),
    []
  );

  const sharedProps = useMemo(() => ({ employeeContext }), [employeeContext]);

  return (
    <div style={{ flex: 1, minHeight: 0, minWidth: 0, display: 'flex', flexDirection: 'column' }}>
      <PageInnerTabs
        tabsConfig={tabsConfig}
        defaultActiveTabId="education"
        sharedProps={sharedProps}
        keepMounted
      />
    </div>
  );
};

export default EmployeeRecordTabs;
